import { COLOR_PALETTE } from 'constants/ui';

export const dashedButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  width: '100%',
  maxWidth: '440px',
  padding: '12px 16px',
  border: ({ palette }) => `1px dashed ${palette.border.input}`,
  borderRadius: ({ shape }) => shape.radius.l,
  backgroundColor: ({ palette }) => palette.background.secondary,
  color: COLOR_PALETTE.BLUE[7],
  cursor: 'pointer',
  transition: 'border-color 0.12s, background-color 0.12s',
  '&:hover': {
    borderColor: COLOR_PALETTE.BRAND[6],
    backgroundColor: COLOR_PALETTE.BRAND[1],
  },
};
